// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"3318":"28944fa4","6609":"f20e3241","7627":"f20e3241"}[chunkId] + ".css";
};